export const API_BASE = "https://kanaiyalal.in/api";

export const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});
